"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InteractiveListItem = void 0;
var _HelpText = _interopRequireDefault(require("./../HelpText/HelpText"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Stars = _interopRequireDefault(require("@mui/icons-material/Stars"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("./../../utils/type-checks/string");
var _useElementSize = require("./../../utils/hooks/useElementSize");
var _styles = require("@mui/material/styles");
var _uuid = require("uuid");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  InteractiveListItem = props => {
    const {
        customTheme = {},
        heightRatio = 1,
        item,
        testId,
        widthRatio = 1
      } = props,
      theme = merge((0, _styles.useTheme)(), customTheme),
      {
        iconColor = theme.palette.primary.main,
        iconColorHover = iconColor,
        IconDefault = _Stars.default,
        IconHover = _Stars.default,
        fragmentId,
        label,
        path,
        styles = {},
        title,
        type,
        url,
        xPosition,
        yPosition
      } = item,
      mergedStyles = merge({
        display: "inline-flex",
        left: `${xPosition * widthRatio}px`,
        position: "absolute",
        top: `${yPosition * heightRatio}px`,
        ".Interactive-Image__icon--isDefault,.Interactive-Image__icon--isHover": {
          background: "#FFFFFF",
          clipPath: "circle(1.4rem)",
          height: "3.55rem",
          width: "3.55rem",
          zIndex: "2"
        },
        ".Interactive-Image__icon--isHover": {
          display: "none"
        },
        "&:hover": {
          ".Interactive-Image__icon--isDefault": {
            display: "none"
          },
          ".Interactive-Image__icon--isHover": {
            display: "inline-block"
          }
        },
        ".Interactive-Image__item-text": {
          background: "#FFFFFF",
          borderRadius: "0.5rem",
          boxShadow: "rgba(0,0,0,0.25) 0 0.2rem 0.4rem",
          display: "inline-block",
          fontFamily: theme.fontFamilies.bold,
          fontSize: "2rem",
          left: "3.5rem",
          marginLeft: "0",
          "svg & ": {
            marginLeft: "1rem"
          },
          padding: "1.5rem 2rem",
          position: "absolute",
          textTransform: "uppercase",
          top: "2.5rem",
          zIndex: "1",
          ".HelpText__icon-button,.HelpText__icon-button--isHover": {
            display: "none"
          },
          ".HelpText__icon-label": {
            margin: "0",
            position: "static"
          }
        }
      }, styles);
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      className: "Interactive-Image__item",
      "data-testid": testId,
      sx: mergedStyles
    }, type === "Caption" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconDefault, {
      className: "Interactive-Image__icon--isDefault",
      sx: {
        fill: iconColor
      }
    }), /*#__PURE__*/_react.default.createElement(IconHover, {
      className: "Interactive-Image__icon--isHover",
      sx: {
        fill: iconColorHover
      }
    }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "span",
      className: "Interactive-Image__item-text"
    }, label)), type === "Link" && (0, _string.isStringOfLength)(path) && /*#__PURE__*/_react.default.createElement(_material.Link, {
      to: path,
      sx: {
        alignItems: "center",
        display: "inline-flex"
      }
    }, /*#__PURE__*/_react.default.createElement(IconDefault, {
      className: "Interactive-Image__icon--isDefault",
      sx: {
        fill: iconColor
      }
    }), /*#__PURE__*/_react.default.createElement(IconHover, {
      className: "Interactive-Image__icon--isHover",
      sx: {
        fill: iconColorHover
      }
    }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "span",
      className: "Interactive-Image__item-text"
    }, label)), type === "Link" && !(0, _string.isStringOfLength)(path) && (0, _string.isStringOfLength)(url) && /*#__PURE__*/_react.default.createElement(_material.Link, {
      href: url,
      target: "_blank",
      sx: {
        alignItems: "center",
        display: "inline-flex"
      }
    }, /*#__PURE__*/_react.default.createElement(IconDefault, {
      className: "Interactive-Image__icon--isDefault",
      sx: {
        fill: iconColor
      }
    }), /*#__PURE__*/_react.default.createElement(IconHover, {
      className: "Interactive-Image__icon--isHover",
      sx: {
        fill: iconColorHover
      }
    }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "span",
      className: "Interactive-Image__item-text"
    }, label)), type === "HelpText" && ((0, _string.isStringOfLength)(title) || (0, _string.isStringOfLength)(fragmentId)) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(IconDefault, {
      className: "Interactive-Image__icon--isDefault",
      sx: {
        color: iconColor
      }
    }), /*#__PURE__*/_react.default.createElement(IconHover, {
      className: "Interactive-Image__icon--isHover",
      sx: {
        color: iconColorHover
      }
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "Interactive-Image__item-text"
    }, /*#__PURE__*/_react.default.createElement(_HelpText.default, {
      customTheme: theme,
      fragmentId: fragmentId,
      title: title
    }, label))));
  };

/**
 * Component to define a main image and float interactive captions/links/help text buttons over the image
 *
 * @visibleName Interactive Image
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.InteractiveListItem = InteractiveListItem;
const InteractiveImage = props => {
  const {
      className,
      customTheme = {},
      image,
      items,
      styles = {},
      testId
    } = props,
    keySeed = (0, _react.useRef)((0, _uuid.v4)()),
    [imageRef, {
      height,
      width
    }] = (0, _useElementSize.useElementSize)(),
    componentClass = (0, _classnames.default)({
      "Interactive-Image": true,
      [`${className}`]: className
    });
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: componentClass,
    component: "div",
    "data-testid": testId,
    ref: imageRef,
    sx: merge({
      maxHeight: `${image.height}px`,
      maxWidth: `${image.width}px`,
      position: "relative"
    }, styles)
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: image.alt,
    src: image.src
  }), /*#__PURE__*/_react.default.createElement(_material.List, {
    className: "Interactive-Image__list",
    sx: {
      position: "static"
    }
  }, items.map((item, index) => /*#__PURE__*/_react.default.createElement(InteractiveListItem, {
    customTheme: customTheme,
    item: item,
    key: `interactive-item__${keySeed.current}__${index}`,
    heightRatio: height / image.height,
    widthRatio: width / image.width
  }))));
};

// Define propTypes;
InteractiveImage.propTypes = {
  /** Custom classname(s) */
  className: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Object describing main image attributes */
  image: _propTypes.default.shape({
    /** Alt. Description of Image */
    alt: _propTypes.default.string.isRequired,
    /** Height of image */
    height: _propTypes.default.number.isRequired,
    /** URL Path to image */
    src: _propTypes.default.string.isRequired,
    /** Width of image */
    width: _propTypes.default.number.isRequired
  }),
  /** Array of objects describing each pop-up detail */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Content fragment id, if this is a "HelpText" type */
    fragmentId: _propTypes.default.string,
    /** Icon for particular interactive item */
    IconDefault: _propTypes.default.any,
    /** Hover icon for particular interactive item */
    IconHover: _propTypes.default.any,
    /** Label of interactive button */
    label: _propTypes.default.string.isRequired,
    /** Path to internal page, if this a "link" type */
    path: _propTypes.default.string,
    /** Custom styles object */
    styles: _propTypes.default.object,
    /** Title of Help Text pop-up window */
    title: _propTypes.default.string,
    /** Type of content/behavior for item */
    type: _propTypes.default.oneOf([/** Hover caption */
    "Caption", /** Pop-up help text */
    "HelpText", /** Link to another location (internal or external) */
    "Link"]).isRequired,
    /** Path to external link, if this is of "link" type */
    url: _propTypes.default.string,
    /** X position item relative to width of main image provided */
    xPosition: _propTypes.default.number.isRequired,
    /** Y position of item relative to height of main image provided */
    yPosition: _propTypes.default.number.isRequired
  })).isRequired,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};
InteractiveListItem.propTypes = {
  customTheme: _propTypes.default.object,
  heightRatio: _propTypes.default.number,
  item: _propTypes.default.shape({
    fragmentId: _propTypes.default.string,
    iconColor: _propTypes.default.string,
    iconColorHover: _propTypes.default.string,
    IconDefault: _propTypes.default.any,
    IconHover: _propTypes.default.any,
    label: _propTypes.default.string.isRequired,
    path: _propTypes.default.string,
    styles: _propTypes.default.object,
    title: _propTypes.default.string,
    type: _propTypes.default.oneOf(["Caption", "HelpText", "Link"]).isRequired,
    url: _propTypes.default.string,
    xPosition: _propTypes.default.number.isRequired,
    yPosition: _propTypes.default.number.isRequired
  }),
  testId: _propTypes.default.string,
  widthRatio: _propTypes.default.number
};

// Export component as default;
var _default = exports.default = InteractiveImage;